import React, { useState, useRef } from 'react'
import New from '../common/New'
import Username from '../Username'
import AdForm from './AdForm';

const AddNew = () => {
    const [showForm, setShowForm] = useState(false);
    const formRef = useRef(null);
    const handleAddNew = () => {
        setShowForm(true);
    };

    return (
        <>
            <Username />
            {showForm && (
                <AdForm
                    setSubmissions={(submissions) => {
                        localStorage.setItem('submissions', JSON.stringify(submissions));
                    }}
                    formRef={formRef}
                    setShowForm={setShowForm}
                />
            )}

            <div className='mt-5 ml-5'>
                <New handleAddNew={handleAddNew} />
            </div>
        </>
    )
}

export default AddNew
